export default __webpack_public_path__ + "static/media/seguros_fianzas.0f344869.png";